import React from 'react';

import './sign_up_page.scss'

import {
  FormWithConstraints,
  FieldFeedbacks,
  FieldFeedback
} from 'react-form-with-constraints';
import AsyncSelect from "react-select/async";
import axios from 'axios';

import { withTranslation } from 'react-i18next';
import './localizations'

let selectBorderColor = '#CED4DA'
const selectStyle = {
  control: (base, state) => ({
    ...base,
    border: `1px solid ${selectBorderColor}`,
    boxShadow: 'none',
    '&:hover': {
      border: `1px solid ${selectBorderColor}`,
    },
    fontFamily: "Montserrat",
    fontWeight: 400,
    height: 55,
    borderRadius: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#7D0052' : 'inherit',
    '&:hover': {backgroundColor: state.isSelected ? '#7D0052' : '#ECECEC'},
  })
}

class SingUpForm extends React.Component {
  state = {
    setInstitutionValue: '',
    selectedInstitutionValue: null,
    setCountryValue: '',
    selectedCountryValue: null,

    doInstitutionCreation: false,
  };

  componentWillMount() {
    this.props.i18n.changeLanguage(this.props.locale || "en");
  }

  handleChange = (e) => {
    const alreadyExistsMessage = document.getElementById('alreadyExistsMessage');
    alreadyExistsMessage.innerHTML = ''

    const target = e.currentTarget;
    target.required = true
    this.form.validateFields(target);
  }

  loadInstitutionOptions = (inputValue) => {
    return axios.get('/institutions/for_select?institution=' + inputValue)
        .then((res) => {
          const institutions = res.data.data;

          if (institutions !== null && institutions !== undefined && institutions.length > 0) {
            return [...institutions, {value: "create_new_institution", label: this.props.t("create-new-institution-option")}]
          } else {
            return [{value: "create_new_institution", label: this.props.t("create-new-institution-option")}]
          }
        })
  };

  handleInstitutionInputChange = value => {
    this.setState({ setInstitutionValue: value });
  };

  handleInstitutionSelectChange = value => {
    this.setState({ selectedInstitutionValue: value });

    const validation = document.getElementById('institution-validation');
    if (validation) {
      document.getElementById('institution-validation').hidden = true
    }

    if (value.value === 'create_new_institution') {
      this.setState({ doInstitutionCreation: true })
    } else {
      this.setState({ doInstitutionCreation: false })
    }
  }

  loadCountryOptions = (inputValue) => {
    return axios.get('/collections/countries?input_value=' + inputValue).then((res) => {
      return res.data.data.map((country) => {
        return { label: country.name, value: country.id }
      });
    } );
  };

  handleCountryInputChange = value => {
    this.setState({ setCountryValue: value });
  };

  handleCountrySelectChange = value => {
    this.setState({selectedCountryValue: value});
  }

  handleNoOptionsMessage = inputValue => {
    const { t } = this.props;

    if (inputValue.length == 0) {
      return t("start-typing-message")
    }
    else {
      return t("no-options-message")
    }
  }

  contactSubmit = event => {
    event.preventDefault();

    this.form.validateFields();

    const emailField = document.getElementById('user[email]').value;
    const alreadyExistsMessage = document.getElementById('alreadyExistsMessage');

    if (this.form.isValid()) {
      axios.get("/check_user_email?user=" + emailField,).then((res) =>
      {
        if(res.data.email === emailField) {
          alreadyExistsMessage.innerHTML = 'An account using this email address already exists'
        } else {
          document.forms["myForm"].submit();
        }
      });
    } else {
      this.setRequired()
    }
  }

  hidePassword = () => {
    const togglePassword = document.getElementById('togglePassword');
    const password = document.getElementById('idPassword');
    const type = password.getAttribute('type') === 'password' ? 'text' : 'password';

    password.setAttribute('type', type);
    togglePassword.classList.toggle('fa-eye-slash');
  }

  setRequired = () => {
    document.getElementById('user[first_name]').required = true
    document.getElementById('user[last_name]').required = true
    document.getElementById('user[job_title]').required = true
    document.getElementById('user[email]').required = true
    document.getElementById('idPassword').required = true

    this.setState({ setValue: '' });
    const { selectedValue } = this.state;
    if(selectedValue == null){
      selectBorderColor = '#A4123F'
    }
  }

  render() {
    const { t } = this.props;

    const { selectedInstitutionValue, selectedCountryValue, doInstitutionCreation } = this.state;

    return (
        <FormWithConstraints
            ref={form => this.form = form}
            onSubmit={this.contactSubmit}
            action='/users' method='post'
            name="myForm"
            noValidate>
          <div className="col-md-6">
            <div>
              <label>{t("first-name-field")}</label>
              <input name="user[first_name]" id="user[first_name]" size="30"
                     onChange={this.handleChange}
                     className="form-control" />
              <FieldFeedbacks for="user[first_name]">
                <FieldFeedback when={value => value.length === 0}><p className="validation-style">{t("field-required-message")}</p></FieldFeedback>
                <FieldFeedback when={value => value.length > 100}><p className="validation-style">Must be maximum 100 characters.</p></FieldFeedback>
                <FieldFeedback when={value => /[<>]/.test(value)}><p className="validation-style">`&lt; &gt;` symbols not allowed.</p></FieldFeedback>
              </FieldFeedbacks>
            </div>
            <div className="field-container">
              <label>{t("last-name-field")}</label>
              <input name="user[last_name]" id="user[last_name]" size="30"
                     onChange={this.handleChange}
                     className="form-control" />
              <FieldFeedbacks for="user[last_name]">
                <FieldFeedback when={value => value.length === 0}><p className="validation-style">{t("field-required-message")}</p></FieldFeedback>
                <FieldFeedback when={value => value.length > 100}><p className="validation-style">Must be maximum 100 characters.</p></FieldFeedback>
                <FieldFeedback when={value => /[<>]/.test(value)}><p className="validation-style">`&lt; &gt;` symbols not allowed.</p></FieldFeedback>
              </FieldFeedbacks>
            </div>
            <div className="field-container">
              <label>{t("job-title-field")}</label>
              <input name="user[job_title]" id="user[job_title]" size="30"
                     onChange={this.handleChange}
                     className="form-control" />
              <FieldFeedbacks for="user[job_title]">
                <FieldFeedback when={value => value.length === 0}><p className="validation-style">{t("field-required-message")}</p></FieldFeedback>
                <FieldFeedback when={value => value.length > 100}><p className="validation-style">Must be maximum 100 characters.</p></FieldFeedback>
                <FieldFeedback when={value => /[<>]/.test(value)}><p className="validation-style">`&lt; &gt;` symbols not allowed.</p></FieldFeedback>
              </FieldFeedbacks>
            </div>
            <div className="field-container">
              <label>{t("institution-name-field")}</label>
              <div id='lop'>
                <AsyncSelect
                    value={selectedInstitutionValue}
                    cacheOptions
                    loadOptions={this.loadInstitutionOptions}
                    onInputChange={this.handleInstitutionInputChange}
                    onChange={this.handleInstitutionSelectChange}
                    styles={selectStyle}
                    placeholder={t("institution-placeholder")}
                    name={'user[institution_id]'}
                    noOptionsMessage={({inputValue}) => this.handleNoOptionsMessage(inputValue)}
                />
              </div>
              <FieldFeedbacks for="user[institution_id]">
                <FieldFeedback when={value => value.length === 0}><p className="validation-style" id='institution-validation'>{t("field-required-message")}</p></FieldFeedback>
              </FieldFeedbacks>
            </div>

            <div className="custom-institution-container" style={{display: doInstitutionCreation ? 'block' : 'none'}}>
              <div className="field-container">
                <label>{t("new-institution-label")}</label>
                <div id='lop'>
                  <input name="user[custom_institution_name]" id="user[custom_institution_name]" size="30"
                         onChange={this.handleChange}
                         placeholder={t("new-institution-placeholder")}
                         className="form-control" />
                </div>
              </div>

              <div className="field-container">
                <label>{t("new-institution-country-label")}</label>
                <div id='lop'>
                  <AsyncSelect
                      value={selectedCountryValue}
                      loadOptions={this.loadCountryOptions}
                      onInputChange={this.handleCountryInputChange}
                      onChange={this.handleCountrySelectChange}
                      styles={selectStyle}
                      placeholder={t("new-institution-country-placeholder")}
                      name={'user[custom_institution_country_id]'}
                      noOptionsMessage={({inputValue}) => this.handleNoOptionsMessage(inputValue)}
                  />
                </div>
              </div>
            </div>

            <div className="field-container">
              <label>{t("email-field")}</label>
              <input type="email" name="user[email]" size="30" id="user[email]"
                     onChange={this.handleChange}
                     className="form-control" />
              <p className="validation-style" id="alreadyExistsMessage"></p>
              <FieldFeedbacks for="user[email]">
                <FieldFeedback when={value => value.length === 0}><p className="validation-style">{t("field-required-message")}</p></FieldFeedback>
                <FieldFeedback when={value => !/\S+@\S+\.\S+/.test(value)}><p className="validation-style">Enter an email address in the correct format, like name@example.com.</p></FieldFeedback>
                <FieldFeedback when={value => /\s/.test(value)}><p className="validation-style">Spaces not allowed.</p></FieldFeedback>
                <FieldFeedback when={value => value.length > 100}><p className="validation-style">Must be maximum 100 characters.</p></FieldFeedback>
                <FieldFeedback when={value => /[<>]/.test(value)}><p className="validation-style">`&lt; &gt;` symbols not allowed.</p></FieldFeedback>
              </FieldFeedbacks>
            </div>
            <div className="field-container">
              <label>{t("password-field")}</label>
              <input type="password" name="user[password]"
                     onChange={this.handleChange}
                     pattern=".{6,}"  className="form-control"  id="idPassword"/>
              <i className="far fa-eye fa-eye-slash" id="togglePassword" onClick={this.hidePassword}></i>
              <FieldFeedbacks for="user[password]">
                <FieldFeedback when={value => value.length === 0}><p className="validation-style">{t("field-required-message")}</p></FieldFeedback>
                <FieldFeedback when="valueMissing" />
                <FieldFeedback when="patternMismatch">
                  <p className="validation-style">Password must contain at least 6 characters.</p>
                </FieldFeedback>
                <FieldFeedback when={value => /\s/.test(value)}><p className="validation-style">Spaces not allowed.</p></FieldFeedback>
                <FieldFeedback when={value => value.length > 100}><p className="validation-style">Must be maximum 100 characters.</p></FieldFeedback>
                <FieldFeedback when={value => /[<>]/.test(value)}><p className="validation-style">`&lt; &gt;` symbols not allowed.</p></FieldFeedback>
              </FieldFeedbacks>
              <p className="password-instruction">{t("password-validation-message")}</p>
            </div>
          </div>
          <div className="field-container">
            <input type="checkbox" value="1" defaultChecked={true}
                   name="user[send_promotion_emails]" id="user_send_promotion_emails"  className="check-box-input" />
            <label className="check-box-label" htmlFor="user_send_promotion_emails"><p>{t("stay-up-text")}</p></label>
          </div>
          <div className="field-container">
            <p dangerouslySetInnerHTML={{__html: t("consent-text")}}></p>
          </div>
          <input name="locale" value={this.props.locale} type='hidden' />
          <div className="field-container">
            <input type="submit" id='signUpSubmit' value={t("create-button")} />
          </div>
        </FormWithConstraints>
    );
  }
}


export default withTranslation()(SingUpForm);
// export default SingUpForm;
